import PropTypes from 'prop-types';
import React from 'react';
import Select from '~/components/ui/Select';
import { withFilterContext } from '~/context/FilterContext';

const CollectionSorting = ({
  sortMethods,
  activeSortMethod,
  setActiveSortMethod,
  selectClassName = '',
}) => (
  <Select
    className={selectClassName}
    attrs={{
      value: activeSortMethod,
      onChange: e => setActiveSortMethod(e.target.value),
      'aria-label': 'Sort By',
    }}
  >
    {Object.keys(sortMethods).map(sortOption => (
      <option
        value={sortMethods[sortOption]}
        key={`collection-sort-${sortOption}`}
      >
        {sortOption}
      </option>
    ))}
  </Select>
);

CollectionSorting.propTypes = {
  sortMethods: PropTypes.object,
  activeSortMethod: PropTypes.string,
  setActiveSortMethod: PropTypes.func,
  selectClassName: PropTypes.string,
};

export default withFilterContext(CollectionSorting);
